import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components/macro'
import SocialNavTitle from './SocialNavTitle'

export const StyledSocialNav = styled.nav`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

function SocialNav({ title, children, ...props }) {
  return (
    <StyledSocialNav {...props}>
      {title && <SocialNavTitle>{title}</SocialNavTitle>}
      {children}
    </StyledSocialNav>
  )
}

SocialNav.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node
}

export default SocialNav
